<form [formGroup]="recoveryForm" (ngSubmit)="onRecovery()">
    <p>
        Bitte geben Sie Ihre E-Mail Adresse an, die Sie für die Registrierung
        verwendet haben.
    </p>

    <div class="mibi-form-group">
        <mibi-form-field>
            <mat-form-field>
                <mat-label>E-Mail</mat-label>
                <input
                    matInput
                    placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                    name="email"
                    formControlName="email"
                    required
                />
            </mat-form-field>
        </mibi-form-field>
    </div>

    <div class="mibi-recocery-actions">
        <a
            class="mibi-recocery-actions__button"
            [routerLink]="[userLinks.login]"
            mat-button
            color="primary"
        >
            Zurück
        </a>
        <button
            class="mibi-recocery-actions__button"
            mat-flat-button
            color="accent"
            type="submit"
            [disabled]="!recoveryForm.valid"
        >
            Passwort zurücksetzen
        </button>
    </div>
</form>
